/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FreelancerReview from './FreelancerReview';

const propTypes = {
    reviews: PropTypes.object.isRequired,
};

class FreelancerDetailsReviews extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAllReviews: false,
        };
        this.toggleShowAllReviews = this.toggleShowAllReviews.bind(this);
    }

    toggleShowAllReviews() {
        const { showAllReviews } = this.state;
        this.setState({
            showAllReviews: !showAllReviews,
        });

        if (this.props.reviews.hasMoreItems) {
            this.props.getMoreData('reviews');
        }
    }

    renderReviews() {
        const { showAllReviews } = this.state;
        const reviews = this.props.reviews.content;
        const items = (showAllReviews ? reviews : reviews.slice(0, 4)).map(
            (item, index) => (
                <div key={index} className="freelancer-reviews__item">
                    <FreelancerReview
                        isAgent={this.props.isAgent}
                        score={item.score}
                        comment={item.comment}
                        date={item.created}
                        author={item.author}
                        jobrequest={item.jobrequest}
                    />
                </div>
            ),
        );
        return (
            <div className="freelancer-reviews">
                <div className="freelancer-reviews__inner">{items}</div>
            </div>
        );
    }

    render() {
        const reviews = this.props.reviews.content;

        return (
            <div className="freelancer-details-section">
                <div className="freelancer-details-section__header">
                    <div className="freelancer-details-section__title">
                        Reviews
                    </div>
                    <div className="freelancer-details-section__btns">
                        {(() => {
                            if (reviews.length > 4) {
                                return (
                                    <button
                                        className="freelancer-details-section__btn"
                                        onClick={this.toggleShowAllReviews}
                                    >
                                        {this.state.showAllReviews
                                            ? 'Minimize'
                                            : 'Read More Reviews'}
                                    </button>
                                );
                            }
                        })()}
                    </div>
                </div>
                <div className="freelancer-details-section__content">
                    {(() => {
                        if (reviews.length === 0) {
                            return (
                                <div>Worker doesn't have any reviews yet.</div>
                            );
                        }
                        return this.renderReviews();
                    })()}
                </div>
            </div>
        );
    }
}

FreelancerDetailsReviews.propTypes = propTypes;

export default FreelancerDetailsReviews;
